var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconClock = function SvgIconClock(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17.5,
    r: 16.25,
    stroke: "#525252",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6828 16.1551C13.1046 15.778 12.3301 15.941 11.953 16.5193C11.5759 17.0975 11.7389 17.872 12.3172 18.2491L13.6828 16.1551ZM24.7854 12.2136C25.2124 11.6712 25.1188 10.8853 24.5764 10.4583C24.034 10.0312 23.248 10.1248 22.821 10.6672L24.7854 12.2136ZM16.394 19.4156L15.7111 20.4626L16.394 19.4156ZM17.6931 19.202L18.6752 19.9752L17.6931 19.202ZM12.3172 18.2491L15.7111 20.4626L17.0768 18.3686L13.6828 16.1551L12.3172 18.2491ZM18.6752 19.9752L24.7854 12.2136L22.821 10.6672L16.7109 18.4288L18.6752 19.9752ZM15.7111 20.4626C16.6763 21.0921 17.9624 20.8806 18.6752 19.9752L16.7109 18.4288C16.7989 18.317 16.9576 18.2909 17.0768 18.3686L15.7111 20.4626Z",
    fill: "#48A9A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.375V7.5625",
    stroke: "#525252",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 27V29.1875",
    stroke: "#525252",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0625 17.5L5.875 17.5",
    stroke: "#525252",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.125 17.5L27.9375 17.5",
    stroke: "#525252",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconClock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/icon-clock.651903013ec7104d67dc60971a160d01.blank.svg";